import React from 'react';
import styled from 'styled-components';
import sx from '../../sx';
import { Box, themeGet } from '../..';

// --------------------------------------------------------
// Card base
const Root = ({
  children,
  as = 'div',
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    as: as,
    sx: sxProp
  }, children);
};
Root.displayName = "Root";
Root.displayName = 'Card';

// --------------------------------------------------------
// Content
const Content = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(ContentStack, {
    sx: sxProp
  }, children);
};
Content.displayName = "Content";
const ContentStack = styled(Box).withConfig({
  displayName: "Card__ContentStack",
  componentId: "sc-1s4rhcz-0"
})(["display:flex;flex-direction:column;justify-content:space-between;flex:1;& > * + *{margin-block-start:", ";}", ""], themeGet('lineHeights.default'), sx);
Content.displayName = 'Card.Content';

// --------------------------------------------------------
// Header
const Header = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    as: "div",
    sx: sxProp
  }, children);
};
Header.displayName = "Header";
Header.displayName = 'Card.Header';

// --------------------------------------------------------
// Body
const Body = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    as: "div",
    sx: sxProp
  }, children);
};
Body.displayName = "Body";
Body.displayName = 'Card.Body';

// --------------------------------------------------------
// Media
// TODO: refs
const Media = ({
  children,
  sx: sxProp,
  src,
  alt
}) => {
  return /*#__PURE__*/React.createElement(CardMediaRoot, {
    sx: sxProp
  }, /*#__PURE__*/React.createElement(Img, {
    src: src,
    alt: alt
  }), children);
};
Media.displayName = "Media";
// TODO: this should be our media object, and
// see: https://github.com/mui/material-ui/blob/24015d1e4bdf135ba6c6091141cab2299d824be5/packages/mui-material/src/CardMedia/CardMedia.js
const CardMediaRoot = styled(Box).withConfig({
  displayName: "Card__CardMediaRoot",
  componentId: "sc-1s4rhcz-1"
})([""]);
const Img = styled.img.withConfig({
  displayName: "Card__Img",
  componentId: "sc-1s4rhcz-2"
})(["display:'block';background-size:'cover';background-repeat:'no-repeat';background-position:'center';object-fit:cover;width:100%;"]);
Media.displayName = 'Card.Media';

// --------------------------------------------------------
// Actions
const Actions = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    sx: sxProp
  }, children);
};
Actions.displayName = "Actions";
Actions.displayName = 'Card.Actions';

// --------------------------------------------------------
// Footer
const Footer = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    sx: sxProp,
    as: "div"
  }, children);
};
Footer.displayName = "Footer";
Footer.displayName = 'Card.Footer';
// --------------------------------------------------------
// Export

export const Card = Object.assign(Root, {
  Content,
  Media,
  Header,
  Body,
  Actions,
  Footer
});